import { useState, useEffect, useRef } from 'react';
import {  Outlet, useLocation, useNavigate } from 'react-router-dom';

// material
import { styled, createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';


import {
  Card,
  Box,
  Typography,
  Collapse,
  Stack,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tab,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  ListItemIcon,
  LinearProgress
} from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';


import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import LocalPoliceOutlinedIcon from '@mui/icons-material/LocalPoliceOutlined';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import CircleSharpIcon from '@mui/icons-material/CircleSharp';


import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAuth } from '../../customContextProviders/AuthContext';


import { APP_CONSTANTS } from '../../../URLConstants';
import { encryptStorage } from '../../../CustomStorage';

import { dateDiffInDays } from '../../../utils/formatTime';
import { ReactComponent as SevereAlertIcon } from "../../../../public/static/dashboard/severealerts.svg";
import { ReactComponent as ModerateAlertIcon } from "../../../../public/static/dashboard/moderatewarnings.svg";


import { GetOrganizationNotifications } from '../../../network/Organization';



// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 78;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'

});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  // paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
    // paddingLeft: theme.spacing(1),
    // paddingRight: theme.spacing(1)
  }
}));


const useStyles = makeStyles({
  locationHistoryTitle: {
    fontSize: 14,
    fontWeight: "bold"
  },

  locationHistoryAddress: {
    fontSize: 12,

  },

  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 1, // Number of lines to show before truncating
    '-webkit-box-orient': 'vertical',
  },

  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    // marginTop: "9%",
    marginRight: "5px",
    width: '100%',
    minWidth: "300px",
    maxWidth: "100%",
    height: "100%",

  },
})





const isAuthenticated = false;
let currentPage = 1;


// ----------------------------------------------------------------------

export default function Notifications () {
  const { sessionUserData } = useAuth()
  const location = useLocation()
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [age, setAge] = useState('');
  const [expanded, setExpanded] = useState(false);
  const [selectedTab, setSelectedTab] = useState('1');


  const handleSelectedTabChange = (_event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleExpandChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const [severeAlertsData, setSevereAlertsData] = useState([1, 2, 3])
  const [moderateAlertsData, setModerateAlertsData] = useState([1, 2])
  const [soundBoxNotifications, setSoundBoxNotifications] = useState({ data: [], loading: false, meta: {} })
  const boxRef = useRef(null);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

  const toggleNotifications = () => {
    setIsNotificationsOpen((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setIsNotificationsOpen(false); // Close the Collapse
    }
  };

  useEffect(() => {
    getSoundBoxNotifications(sessionUserData?.user?.organization?.id, currentPage, 10);
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

 
  function getSoundBoxNotifications(organizationId, pageNo, limit) {

    setSoundBoxNotifications(prevState => ({
      ...prevState,
      loading: true
    }));

    GetOrganizationNotifications(organizationId, pageNo, limit).then((res) => {
      //  setSoundBoxNotifications(soundBoxNotifications => res?.data?.data?.notifications)

      setSoundBoxNotifications(prevState => ({
        ...prevState,
        data: [
          ...(prevState?.data),
          ...(res?.data?.data?.notifications?.data?.device || [])
        ],
        meta: res?.data?.data?.notifications,
        loading: false
      }));



    }).catch((_err) => {
      setSoundBoxNotifications(prevState => ({
        ...prevState,
        loading: false
      }));

    })

  }

  function openMerchantProfile(id) {
    navigate('/dashboard/soundboxdevicedetails', { state: { merchantId: id, organizationId: sessionUserData?.user?.organizationId } });
  }




return   (
    <> {
          location?.pathname !== '/dashboard/soundboxdevicedetails' ?
            <Card id="notification_alerts_card" className={classes.cardWithBorder} sx={{ height: "100%", }}>
              <Box sx={{ mt: 2, }}>
                <Stack direction="row" sx={{ p: 2 }} spacing={2} alignItems="center" justifyContent="space-between">
                  <Typography sx={{ fontWeight: 700, fontSize: "18px", lineHeight: "23px", color: "#171D40" }}>Notifications</Typography>
                </Stack>
                <Accordion sx={{ mt: 2, }}
                  expanded={expanded === "device_analytics"}
                  onChange={handleExpandChange('device_analytics')}>
  
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#C30A0A" }} />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{ background: "rgba(195, 10, 10, .1)", minHeight: "20px" }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                      <SevereAlertIcon color="#C30A0A" />
                      <Typography sx={{ fontWeight: 600, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                        Device Analytics
                      </Typography>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails sx={{ bgcolor: 'rgba(195, 10, 10, .1)', pl: 4 }}>
  
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-start"
                      alignItems="flex-start">
  
                      <Grid item sx={{ textAlign: 'left' }} xs={1}>
                        <FiberManualRecordRoundedIcon sx={{ fontSize: 12, color: '#C30A0A' }} />
                      </Grid>
                      <Grid item sx={{ textAlign: 'left' }} xs={5.5}>
                        <Typography sx={{ fontWeight: 600, color: "#171D40", fontStyle: "normal", fontSize: "14px" }}>Reboot Count : </Typography>
                      </Grid>
                      <Grid item sx={{ textAlign: 'left' }} xs={5.5}>
                        <Typography sx={{ fontWeight: 600, color: "#171D40", fontStyle: "normal", fontSize: "14px" }}>{soundBoxNotifications?.meta?.device_analytics?.reboot_device}</Typography>
                      </Grid>
                      <Grid item sx={{ textAlign: 'left' }} xs={1}>
                        <FiberManualRecordRoundedIcon sx={{ fontSize: 12, color: '#C30A0A' }} />
                      </Grid>
                      <Grid item sx={{ textAlign: 'left' }} xs={5.5}>
                        <Typography sx={{ fontWeight: 600, color: "#171D40", fontStyle: "normal", fontSize: "14px" }}>Latency Delay : </Typography>
                      </Grid>
                      <Grid item sx={{ textAlign: 'left' }} xs={5.5}>
                        <Typography sx={{ fontWeight: 600, color: "#171D40", fontStyle: "normal", fontSize: "14px" }}>{soundBoxNotifications?.meta?.device_analytics?.letacy_delay}</Typography>
                      </Grid>
                    </Grid>
  
                  </AccordionDetails>
                </Accordion>
  
                <Accordion sx={{ mt: 2, }}
                  expanded={expanded === "device_attention"}
                  onChange={handleExpandChange('device_attention')}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "#C30A0A" }} />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    sx={{ background: "rgba(195, 10, 10, .1)", minHeight: "20px" }}
                  >
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                      <SevereAlertIcon color="#C30A0A" />
  
                      <Typography sx={{ fontWeight: 600, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                        {soundBoxNotifications?.meta?.device_need_attenttion}  Devices need attention
                      </Typography>
  
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails sx={{ bgcolor: 'rgba(195, 10, 10, .1)', pl: 2, overflow: 'scroll', maxHeight: 400 }}>
                    <List>
                      {soundBoxNotifications?.data?.map((item, _index) => (
                        <ListItem disablePadding
                          secondaryAction={
                            <IconButton edge="end" aria-label="profile" onClick={() => openMerchantProfile(item?.merchant_id)}>
                              <NavigateNextRoundedIcon />
                            </IconButton>
                          }
                          key={item?.merchant_id}
                        >
                          <ListItemIcon>
                            <CircleSharpIcon sx={{ color: "#C30A0A", fontSize: 9 }} />
                          </ListItemIcon>
                          <ListItemButton onClick={() => openMerchantProfile(item?.merchant_id)}>
                            <ListItemText sx={{
                              '& .MuiTypography-root': {
                                fontSize: 12
                              }
  
                            }} primary={item?.name} className={classes?.ellipsis} />
                          </ListItemButton>
  
                        </ListItem>
                      ))
  
                      }
                    </List>
                    <Box sx={{ textAlign: 'center' }}>
                      {
                        soundBoxNotifications?.meta?.data?.hasNextPage ?
                          <Button variant="outlined" onClick={() => {
                            currentPage += 1;
                            getSoundBoxNotifications(sessionUserData?.user?.organizationId, currentPage, 10)
                          }}  >Load more </Button>
                          :
                          null
                      }
                    </Box>
                    {/* <Typography sx={{fontStyle:'bold',fontWeight:600,textAlign:'center'}}>Upcoming feature</Typography>
                    <Typography sx={{fontSize:12}}>This section will soon display all device-related information</Typography> */}
                  </AccordionDetails>
                </Accordion>
              </Box>
              {soundBoxNotifications?.loading ? <LinearProgress color="success" /> : null}
            </Card>
            :
            null
        }
  
        {
          encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_P_DASHBOARD) === "PROY" ?
            <Card id="notification_alerts_card" className={classes.cardWithBorder} sx={{ height: "100%", }}>
  
              <Box sx={{ mt: 2, }}>
                <Stack direction="row" sx={{ p: 2 }} spacing={2} alignItems="center" justifyContent="space-between">
                  <Typography sx={{ fontWeight: 700, fontSize: "18px", lineHeight: "23px", color: "#171D40" }}>Notifications</Typography>
                  <FormControl sx={{ minWidth: 150 }} size="small">
                    <InputLabel id="demo-simple-select-helper-label">Severity Level</InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={age}
                      label="Severity Level"
                      onChange={handleChange}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={10}>Severe</MenuItem>
                      <MenuItem value={20}>Mild</MenuItem>
                      <MenuItem value={30}>Low</MenuItem>
                    </Select>
  
                  </FormControl>
  
  
                </Stack>
  
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={selectedTab}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleSelectedTabChange} aria-label="lab API tabs example">
                        <Tab wrapped label="Most recent" value="1" />
                        <Tab wrapped label="Yesterday" value="2" />
                        <Tab wrapped label="Day Before" value="3" />
                      </TabList>
                    </Box>
                    <TabPanel sx={{ p: 0, pt: 2 }} value="1">
                      <Typography sx={{ pl: 3, fontWeight: 600, fontSize: "14px", lineHeight: "18px", color: "#535353" }}>Severe</Typography>
  
                      {severeAlertsData.filter(obj => obj?.severty === 'SEVERE').slice(0, 5).map((item, index) => (
  
                        <Accordion sx={{
                          mt: 2,
  
                        }}
                          expanded={expanded === index}
                          onChange={handleExpandChange(index)}
                          key={item?.severty}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: "#C30A0A" }} />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={{ background: "rgba(195, 10, 10, .1)", minHeight: "20px" }}
                          >
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                              <SevereAlertIcon color="#C30A0A" />
                              {
                                index === 0 ?
  
                                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                                    Device may be tampered
                                  </Typography>
                                  :
                                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                                    7 devices require attention
                                  </Typography>
                              }
                            </Stack>
  
  
                          </AccordionSummary>
                          <AccordionDetails sx={{ bgcolor: 'rgba(195, 10, 10, .1)' }}>
                            {
                              index === 0 ?
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                >
                                  <Grid sx={{ textAlign: 'center' }} xs={3}>
                                    <CallOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Call</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} xs={3}>
                                    <SupervisorAccountOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Details</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} item xs={3}>
                                    <CheckCircleOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Mark Resolved</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} item xs={3}>
                                    <LocalPoliceOutlinedIcon />
                                    <Button size="small" sx={{ fontSize: 12 }}>Police Stations</Button>
                                  </Grid>
                                </Grid>
                                :
                                <Typography>
                                  No Notifications
                                </Typography>
                            }
                          </AccordionDetails>
                        </Accordion>
                      ))}
  
  
  
  
  
                      <Typography sx={{ pl: 3, mt: 2, fontWeight: 600, fontSize: "14px", lineHeight: "18px", color: "#535353" }}>Moderate</Typography>
  
                      {severeAlertsData.filter(obj => obj?.severty === 'MEDIUM').slice(0, 5).map((item, index) => (
                        <Accordion    key={item?.severty} sx={{ mt: 2, }} expanded={expanded === item?.severty + index} onChange={handleExpandChange(item?.severty + index)}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={{ minHeight: "20px" }}
                         
                          >
  
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                              <ModerateAlertIcon color="#FF9900" />
                              <Typography sx={{ fontWeight: 700, fontSize: "14px", lineHeight: "14px" }}>
                                7 devices require attention
                              </Typography>
                            </Stack>
  
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              {item?.message} {dateDiffInDays(new Date(item?.timestamp), new Date())}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      ))}
  
                    </TabPanel>
                    <TabPanel sx={{ p: 0, pt: 2 }} value="2">
  
                      <Typography sx={{ pl: 3, fontWeight: 600, fontSize: "14px", lineHeight: "18px", color: "#535353" }}>Severe</Typography>
  
                      {severeAlertsData.filter(obj => obj?.severty === 'SEVERE' && dateDiffInDays(new Date(obj?.timestamp), new Date()) === 1).slice(0, 5).map((item, index) => (
  
                        <Accordion sx={{
                          mt: 2,
  
                        }}
                          expanded={expanded === index}
                          onChange={handleExpandChange(index)}
                          key={item?.id}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: "#C30A0A" }} />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={{ background: "rgba(195, 10, 10, .1)", minHeight: "20px" }}
                          >
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                              <SevereAlertIcon color="#C30A0A" />
                              {
                                index === 0 ?
  
                                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                                    Device may be tampered
                                  </Typography>
                                  :
                                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                                    7 devices require attention
                                  </Typography>
                              }
                            </Stack>
  
  
                          </AccordionSummary>
                          <AccordionDetails sx={{ bgcolor: 'rgba(195, 10, 10, .1)' }}>
                            {
                              index === 0 ?(
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                >
                                  <Grid sx={{ textAlign: 'center' }} xs={3}>
                                    <CallOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Call</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} xs={3}>
                                    <SupervisorAccountOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Details</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} item xs={3}>
                                    <CheckCircleOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Mark Resolved</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} item xs={3}>
                                    <LocalPoliceOutlinedIcon />
                                    <Button size="small" sx={{ fontSize: 12 }}>Police Stations</Button>
                                  </Grid>
                                </Grid>
                              ):(
  
                                <Typography>
                                  No Notifications
                                </Typography>
                            )}
  
                          </AccordionDetails>
                        </Accordion>
  
                      ))}
  
                      <Typography sx={{ pl: 3, mt: 2, fontWeight: 600, fontSize: "14px", lineHeight: "18px", color: "#535353" }}>Moderate</Typography>
  
                      {severeAlertsData.filter(obj => obj?.severty === 'MEDIUM' && dateDiffInDays(new Date(obj?.timestamp), new Date()) === 1).slice(0, 5).map((item, index) => (
                        <Accordion sx={{ mt: 2, }} key={item?.message} expanded={expanded === item?.severty + index} onChange={handleExpandChange(item?.severty + index)}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={{ minHeight: "20px" }}
                          >
  
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                              <ModerateAlertIcon color="#FF9900" />
                              <Typography sx={{ fontWeight: 700, fontSize: "14px", lineHeight: "14px" }}>
                                7 devices require attention
                              </Typography>
                            </Stack>
  
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              {item?.message}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      ))}
  
  
                    </TabPanel>
                    <TabPanel sx={{ p: 0, pt: 2 }} value="3">
                      <Typography sx={{ pl: 3, fontWeight: 600, fontSize: "14px", lineHeight: "18px", color: "#535353" }}>Severe</Typography>
  
                      {severeAlertsData.filter(obj => obj?.severty === 'SEVERE' && dateDiffInDays(new Date(obj?.timestamp), new Date()) > 2).slice(0, 5).map((item, index) => (
  
                        <Accordion sx={{
                          mt: 2,
  
                        }}
                          key={item}
                          expanded={expanded === index}
                          onChange={handleExpandChange(index)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: "#C30A0A" }} />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={{ background: "rgba(195, 10, 10, .1)", minHeight: "20px" }}
                          >
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                              <SevereAlertIcon color="#C30A0A" />
                              {
                                index === 0 ?
  
                                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                                    Device may be tampered
                                  </Typography>
                                  :
                                  <Typography sx={{ fontWeight: 700, color: "#C30A0A", fontStyle: "normal", fontSize: "14px", lineHeight: "14px" }}>
                                    7 devices require attention
                                  </Typography>
                              }
                            </Stack>
  
  
                          </AccordionSummary>
                          <AccordionDetails sx={{ bgcolor: 'rgba(195, 10, 10, .1)' }}>
                            {
                              index === 0 ?
                                <Grid
                                  container
                                  direction="row"
                                  justifyContent="flex-start"
                                  alignItems="flex-start"
                                >
                                  <Grid sx={{ textAlign: 'center' }} xs={3}>
                                    <CallOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Call</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} xs={3}>
                                    <SupervisorAccountOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Details</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} item xs={3}>
                                    <CheckCircleOutlinedIcon />
                                    <Button sx={{ fontSize: 12 }} size="small">Mark Resolved</Button>
                                  </Grid>
                                  <Grid sx={{ textAlign: 'center' }} item xs={3}>
                                    <LocalPoliceOutlinedIcon />
                                    <Button size="small" sx={{ fontSize: 12 }}>Police Stations</Button>
                                  </Grid>
                                </Grid>
                                :
  
                                <Typography>
                                  No Notifications
                                </Typography>
  
  
  
                            }
  
                          </AccordionDetails>
                        </Accordion>
  
                      ))}
  
                      <Typography sx={{ pl: 3, mt: 2, fontWeight: 600, fontSize: "14px", lineHeight: "18px", color: "#535353" }}>Moderate</Typography>
  
                      {severeAlertsData.filter(obj => obj?.severty === 'MEDIUM' && dateDiffInDays(new Date(obj?.timestamp), new Date()) > 2).map((item, index) => (
                        <Accordion sx={{ mt: 2, }} key={item?.severty} expanded={expanded === item?.severty + index} onChange={handleExpandChange(item?.severty + index)}>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            sx={{ minHeight: "20px" }}
                          >
  
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                              <ModerateAlertIcon color="#FF9900" />
                              <Typography sx={{ fontWeight: 700, fontSize: "14px", lineHeight: "14px" }}>
                                7 devices require attention
                              </Typography>
                            </Stack>
  
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              {item?.message}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      ))}
  
                    </TabPanel>
                  </TabContext>
                </Box>
  
  
  
  
              </Box>
            </Card>
            :
            null
        }
  </>
  )
        
    };
